// extracted by mini-css-extract-plugin
export var blue = "_19-g";
export var brand = "_19-c";
export var darkGrey = "_19-f";
export var disabled = "_19-6";
export var disabledSubtle = "_19-7";
export var error = "_19-8";
export var green = "_19-h";
export var grey = "_19-e";
export var icon = "_19-0";
export var inherit = "_19-b";
export var lightGrey = "_19-d";
export var orange = "_19-j";
export var pink = "_19-l";
export var primary = "_19-1";
export var purple = "_19-m";
export var quaternary = "_19-4";
export var quinary = "_19-5";
export var red = "_19-k";
export var secondary = "_19-2";
export var success = "_19-a";
export var tertiary = "_19-3";
export var warning = "_19-9";
export var white = "_19-n";
export var yellow = "_19-i";